import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetRoadmapsList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("RoadMapGroupSimple/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetRoadmapById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("RoadMapGroupSimple/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateOrUpdateRoadmap extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("RoadMapGroupSimple/CreateUpdate");
  }
}

class DeleteARoadmapGroup extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("RoadMapGroupSimple/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  GetRoadmapsList,
  GetRoadmapById,
  CreateOrUpdateRoadmap,
  DeleteARoadmapGroup,
};
